<script>
import {
  computed, defineComponent, watch, ref,
} from '@vue/composition-api';
import DashboardShopsGraph from './DashboardShopsGraph.vue';
import Loader from '../Loader.vue';
import { useShopsStats } from '../../composables/useShopsStats';
import { useManagerDashboard } from '../../composables/useManagerDashboard';
import { useVuexSellerStores } from '../../composables/useVuexSellerStores';

export default defineComponent({
  components: {
    DashboardShopsGraph,
    Loader,
  },
  setup(props, { root }) {
    const {
      load, loading, eventsResults, conversionsByStoreId,
    } = useShopsStats();
    const { stores: sellerStores } = useVuexSellerStores(root);
    const { currentRevenue, storeSelected, updatedAt } = useManagerDashboard();

    const customer = computed(() => root.$store.state.customer);
    const conversionTableHeaders = ref([
      {
        text: 'Lojas',
        value: 'storeId',
        align: 'center',
        sortable: false,
        width: '50%',
      },
      {
        text: 'Valor total de venda',
        value: 'conversion',
        align: 'center',
        sortable: false,
        width: '50%',
      },
    ]);
    const datatablePaginationConfig = ref({
      sortBy: 'conversion',
      descending: true,
    });

    const getStoreNameById = (storeId) => {
      const findStore = sellerStores.value.find((s) => s.id === storeId);
      return findStore.name;
    };

    watch(
      currentRevenue,
      async () => {
        await load(
          customer.value.id,
          storeSelected.value.id,
          currentRevenue.value.date.getFullYear(),
          currentRevenue.value.date.getMonth(),
        );
      },
      { immediate: true },
    );

    return {
      loading,
      updatedAt,
      eventsResults,
      conversionTableHeaders,
      datatablePaginationConfig,
      conversionsByStoreId,
      getStoreNameById,
      sellerStores,
    };
  },
});
</script>

<template>
  <div>
    <div v-if="!loading">
      <v-container class="pa-0">
        <v-layout
          class="header"
          column
        >
          <h1 class="header__description">
            Estes são seus resultados do Shops do <strong>mês</strong>:
          </h1>
          <h3 class="header__date__update mt-2">
            Atualizado em: {{ updatedAt.date }} às {{ updatedAt.hours }}
          </h3>
        </v-layout>
        <v-layout v-if="!!eventsResults.pageView">
          <DashboardShopsGraph
            :events-results="eventsResults"
          />
        </v-layout>
        <v-layout
          v-if="!!eventsResults.pageView"
          justify-center
        >
          <v-data-table
            :headers="conversionTableHeaders"
            :items="conversionsByStoreId"
            :pagination.sync="datatablePaginationConfig"
            no-data-text="Sem conversões do shops no mês"
            rows-per-page-text="N° de linhas"
            class="stores-conversion"
          >
            <template #items="{ item }">
              <td class="text-xs-center">
                {{ getStoreNameById(item.storeId) }}
              </td>
              <td class="text-xs-center">
                R$ {{ item.conversion.toLocaleString() }}
              </td>
            </template>
          </v-data-table>
        </v-layout>
        <div
          v-if="!eventsResults.pageView"
          class="text-xs-center mt-5"
        >
          Ops, não foram encontrados resultados neste mês...
        </div>
      </v-container>
    </div>
    <div v-else>
      <Loader class="mt-4" />
    </div>
  </div>
</template>

<style lang="scss">
.header {
  &__description {
    font-family: 'Neue-Metana';
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    line-height: 22px;
    &__seller {
      font-weight: 600;
    }
  }
  &__date {
    margin-top: 2rem;
    &__update {
    font-family: 'Nunito Sans';
    font-style: normal;
    font-weight: 600;
    font-size: 10px;
    line-height: 14px;
    color: #959595;
    }
  }
}

.stores-conversion {
  font-family: 'Nunito Sans';
  max-width: 380px;
  border-radius: 18px;
  padding: 12px;
  background: white;
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.1);
}
</style>
